import { businessQuotesService } from '@/services/quotes/business';
import type {
  CreateBusinessQuotePayload,
  CreateQuoteResponse,
} from '@/services/quotes/types';
import { ValidationError } from '@/shared/exceptions/validation.error';
import { useMutation } from '@tanstack/react-query';

export function useCreateBusinessQuote() {
  return useMutation<
    { success: boolean; data?: CreateQuoteResponse; error?: string },
    Error | ValidationError,
    CreateBusinessQuotePayload
  >({
    mutationKey: ['quotes', 'create', 'business'],
    mutationFn: async (payload: CreateBusinessQuotePayload) => {
      try {
        const response = await businessQuotesService.createQuote(payload);
        if (!response.success) throw new Error(response.error || 'Erro');
        return response;
      } catch (error) {
        if (error instanceof ValidationError) throw error;
        throw error instanceof Error ? error : new Error('Erro');
      }
    },
  });
}
